import React from 'react';
import './footer.scss';

const Footer = ({ ...rest }) => {
  return <footer className={'footer'} {...rest} />;
};

export default Footer